const marketingActions = {
  modal: {
    type: 'Tipo',
    bonus: 'Pago',
    discount: 'Campaña',
    date: 'Fecha',
    store: 'Tienda',
    country: 'País',
    products: 'Productos',
    name: 'Nombre',
    actionText: 'Texto de la acción',
    priceplans: 'Planes de precios',
    storeMarketingAction: 'Añadir nueva acción',
    updateMarketingAction: 'Actualizar acción',
  },
  messages: {
    success: 'Acción guardada correctamente',
    destroy: 'Acción eliminada correctamente',
  },
  actions: 'Acciones de marketing',
  showing: 'Mostrando',
  actionsOf: 'Acciones de',
  noActionsFound: 'No se encontraron acciones',
  addNew: 'Añadir nueva acción',
};

export default marketingActions;
